module.exports = __webpack_public_path__ + "static/media/ic-recommend-engine@2x.fb84cd19.png";